/** Scope carried from Billing into existing document screens. Invalid scope never widens to all customers. */
export function parseBillingDocumentScope(search: string) {
  const query = new URLSearchParams(search);
  const start = query.get('start_date') || '';
  const end = query.get('end_date') || '';
  const customers = Array.from(new Set(query.getAll('customer_code').map(s => s.trim()).filter(Boolean)));
  const scoped = query.has('start_date') || query.has('end_date') || query.has('customer_code');
  const validDate = (s: string) => /^\d{4}-\d{2}-\d{2}$/.test(s) && Number.isFinite(Date.parse(s)) && new Date(s).toISOString().slice(0, 10) === s;
  const lastDay = validDate(start) ? new Date(Date.UTC(Number(start.slice(0, 4)), Number(start.slice(5, 7)), 0)).getUTCDate() : 0;
  const halfMonth = validDate(start) && validDate(end) && start.slice(0, 7) === end.slice(0, 7) &&
    ((start.endsWith('-01') && end.endsWith('-15')) || (start.endsWith('-16') && Number(end.slice(8)) === lastDay));
  return {
    scoped,
    invalid: scoped && (!halfMonth || customers.length === 0 || customers.some(c => c.length > 50)),
    start_date: start,
    end_date: end,
    customer_codes: customers,
    date_basis: query.get('date_basis') === 'invoice_date' ? 'invoice_date' as const : 'delivery_date' as const,
  };
}
